import type {FC} from 'react';

import {useI18n} from '@yourcoach/i18n';

import ProgramGroupsSVG from '../../../../assets/icons/empty-state/program-groups.svg';
import {NoResultsView} from '../../../../components/NoResultsView';
import {msi} from '../../../../styles';
import {isIamCoach} from '../../../../utils/entity/isIamCoach';
import {logger} from '../../../../utils/logger';
import {platform} from '../../../../utils/platform';

type Props = {
  onContactCoachClick: () => void;
};

export const ClientCoursesNoResultsView: FC<Props> = ({
  onContactCoachClick,
}) => {
  const {t} = useI18n();

  return (
    <NoResultsView
      buttonScheme={isIamCoach() ? 'primary' : 'secondary'}
      buttonText={t('shared:contact_coach')}
      icon={ProgramGroupsSVG}
      iconColor={isIamCoach() ? 'icon4' : 'icon5'}
      iconSize={msi(platform.isNative ? 100 : 160)}
      onButtonClick={() => {
        logger.event('contact_coach_tap', {
          place: 'program_view',
        });
        onContactCoachClick();
      }}
      text={t('shared:coach_has_no_groups_you_can_send_request')}
    />
  );
};
